import React from 'react'
import Layout from '../../components/Layout'

export default () => (
  <Layout>
    <section className="section">
      <div className="container">
        <div className="content">
          <h1>!Gracias!</h1>
          <p>En un monento nos comunicaremos y atenderemos tu petición</p>
        </div>
      </div>
    </section>
  </Layout>
)
